/**
 * Single Project Post Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initSingleProjectPost() {
        const blocks = document.querySelectorAll('.single-project-post');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] single-project-post block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSingleProjectPost);
    } else {
        initSingleProjectPost();
    }
})();